
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.586 6.155a.831.831 0 00-.163-.244l-5-5a.83.83 0 00-.245-.163C8.153.736 8.127.729 8.1.72a.826.826 0 00-.216-.042c-.017-.002-.033-.011-.05-.011H2c-.919 0-1.667.747-1.667 1.666v13.334c0 .919.748 1.666 1.667 1.666h10c.92 0 1.667-.747 1.667-1.666V6.5c0-.017-.01-.033-.011-.052a.793.793 0 00-.043-.215c-.008-.027-.015-.053-.027-.078zm-2.764-.488H8.667V3.512l2.155 2.155zM2 15.667V2.333h5V6.5c0 .46.373.833.833.833H12l.002 8.334H2z"}}),_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M3.668 8.982h6.667v1.667H3.668V8.982zm0 3.333h6.667v1.667H3.668v-1.667zm0-6.666h1.667v1.666H3.668V5.649z"}})])
          )
        }
      }
    